import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"
}), 'FormatQuote');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatQuote.js
// module id = 3879
// module chunks = 2